/**
 * Created by Ivan on 20.06.2026
 */

const LorysDerbyMerge2Adapter = {
    SubscribeToEvents: function () {
        cleverapps.missionManager.on("add", (mission) => {
            if (!Merge2.current) {
                return;
            }
            if (mission.getType() === Mission.TYPE_LORYS_DERBY) {
                cleverapps.eventBus.trigger("updateExtraBar");
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            }
        });

        cleverapps.missionManager.on("remove", (mission) => {
            if (mission.getType() === Mission.TYPE_LORYS_DERBY) {
                cleverapps.extraBar.removeIcon(LorysDerbyExtraBarIcon);
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
            }
        });

        cleverapps.missionManager.on("clickReceiveButton", (type) => {
            if (type !== Mission.TYPE_LORYS_DERBY) {
                return;
            }

            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_LORYS_DERBY);
            if (!mission || !mission.isRunning() || !mission.logic.isStageCompleted()) {
                return;
            }

            mission.logic.updateIcon();

            let rewards = {};
            while (mission.logic.isStageCompleted()) {
                const stage = mission.logic.getCurrentStage();
                rewards = RewardsList.sumRewards(rewards, stage.prize);
                mission.logic.updateStage();
            }

            cleverapps.focusManager.display({
                focus: "lorysDerbyReward",
                stack: true,
                actions: [
                    function (f) {
                        new RewardWindow(new RewardsList(rewards, {
                            event: cleverapps.EVENTS.LORYS_DERBY.EARN,
                            toBubbleStack: true
                        }));
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    },
                    function (f) {
                        const ViewClass = mission.isRunning() && mission.getViewClass();
                        if (!ViewClass) {
                            f();
                            return;
                        }

                        new ViewClass(mission);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                ]
            });
        });

        cleverapps.missionManager.on("lorysDerbyPlay", () => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_LORYS_DERBY);
            if (!mission || !mission.isRunning() || !Merge2.current) {
                return;
            }

            const customersList = Merge2.current.customers.listCustomersWithRecipe().filter((customer) => !customer.recipe.sideQuest);
            if (!customersList.length) {
                return;
            }

            Merge2.current.changeMode(Merge2.MODE_GAME, () => {});

            cleverapps.focusManager.whenFreeFocus(() => {
                cleverapps.focusManager.display({
                    focus: "LorysDerbyShowPlayHint",
                    keepControls: true,
                    actions: [
                        (f) => {
                            const customerView = customersList[0].onGetView();
                            FingerView.hintTap(customerView, {
                                runOnce: true,
                                callback: f
                            });
                            cleverapps.focusManager.setEventNodes([customerView]);

                            cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).ordersTable.scrollToRow(customersList[0].recipe.index);
                        }
                    ]
                });
            });
        });

        cleverapps.eventBus.on("earn_stars", (amount) => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_LORYS_DERBY);
            if (mission && mission.isRunning()) {
                mission.logic.incLevel(amount);
            }
        });

        cleverapps.eventBus.on("updateExtraBar", () => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_LORYS_DERBY);
            if (!mission || !mission.isRunning()) {
                return;
            }

            if (cleverapps.resolution.isVertical()) {
                cleverapps.extraBar.removeIcon(LorysDerbyExtraBarIcon, true);
            } else {
                cleverapps.extraBar.addIcon(LorysDerbyExtraBarIcon);
            }
        });
    }
};

cleverapps.whenAllInitialized(() => LorysDerbyMerge2Adapter.SubscribeToEvents());
